import { useState } from 'react';
import { s, txStyles } from './TissStyles';
import { opLabels } from './TissConstants';
import {
  formatDateTime,
  parseElegibilidadeData,
  parseSolicitacaoData,
  parseTesteConexaoData,
  parseStatusGuiaData,
  parseCancelamentoData,
  parseLoteData,
  parseStatusLoteData,
  downloadXml,
} from './TissHelpers';
import { descreverGlosa } from './TissGlosas';
import { XmlViewer } from './TissShared';

export default function TransacaoDetalheModal({ detail, onClose }) {
  const op = detail.operacao;
  const isElegibilidade = op === 'elegibilidade';
  const isTesteConexao = op === 'teste_conexao';
  const isSolicitacao = ['solicitacao_procedimento', 'worker_envio_guia', 'reenvio_guia'].includes(op);
  const isStatusGuia = op === 'status_guia';
  const isCancelamento = op === 'cancelamento_guia';
  const isEnvioLote = op === 'envio_lote' || op === 'reenvio_lote';
  const isStatusLote = op === 'status_lote';

  const elegData = isElegibilidade ? parseElegibilidadeData(detail.xml_request, detail.xml_response) : null;
  const solData = isSolicitacao ? parseSolicitacaoData(detail.xml_request, detail.xml_response) : null;
  const testeData = isTesteConexao ? parseTesteConexaoData(detail.xml_request, detail.xml_response) : null;
  const statusGuiaData = isStatusGuia ? parseStatusGuiaData(detail.xml_request, detail.xml_response) : null;
  const cancelData = isCancelamento ? parseCancelamentoData(detail.xml_request, detail.xml_response) : null;
  const loteData = isEnvioLote ? parseLoteData(detail.xml_request, detail.xml_response) : null;
  const statusLoteData = isStatusLote ? parseStatusLoteData(detail.xml_request, detail.xml_response) : null;

  const httpColor = !detail.http_status ? '#999' : detail.http_status < 300 ? '#2e7d32' : detail.http_status < 400 ? '#e65100' : '#c62828';

  const [endpointCopied, setEndpointCopied] = useState(false);
  const copyEndpoint = () => {
    if (detail.endpoint) {
      navigator.clipboard.writeText(detail.endpoint).then(() => {
        setEndpointCopied(true);
        setTimeout(() => setEndpointCopied(false), 2000);
      });
    }
  };

  return (
    <div style={s.modal} onClick={onClose}>
      <div style={{ ...s.modalContent, maxWidth: '940px', maxHeight: '90vh', padding: '0' }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ padding: '20px 24px 0', borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
          <div style={txStyles.header}>
            <div style={txStyles.headerLeft}>
              <h2 style={txStyles.headerTitle}>Transacao #{detail.id}</h2>
              <div style={txStyles.headerBadges}>
                <span style={txStyles.opBadge}>{opLabels[op] || op}</span>
                <span style={{
                  ...s.badge,
                  backgroundColor: detail.sucesso !== false ? '#e8f5e9' : '#ffebee',
                  color: detail.sucesso !== false ? '#2e7d32' : '#c62828',
                }}>{detail.sucesso !== false ? 'Sucesso' : 'Erro'}</span>
              </div>
            </div>
            <button style={txStyles.closeBtn} onClick={onClose} title="Fechar">&times;</button>
          </div>
        </div>

        {/* Body scrollable */}
        <div style={{ padding: '20px 24px', overflowY: 'auto', maxHeight: 'calc(90vh - 80px)' }}>

          {/* Meta cards */}
          <div style={txStyles.metaRow}>
            <div style={txStyles.metaCard}>
              <span style={txStyles.metaIcon}>&#128339;</span>
              <div>
                <div style={txStyles.metaLabel}>Inicio</div>
                <div style={txStyles.metaValue}>{formatDateTime(detail.inicio)}</div>
              </div>
            </div>
            <div style={txStyles.metaCard}>
              <span style={txStyles.metaIcon}>&#128340;</span>
              <div>
                <div style={txStyles.metaLabel}>Fim</div>
                <div style={txStyles.metaValue}>{formatDateTime(detail.fim)}</div>
              </div>
            </div>
            <div style={txStyles.metaCard}>
              <span style={txStyles.metaIcon}>&#9202;</span>
              <div>
                <div style={txStyles.metaLabel}>Duracao</div>
                <div style={txStyles.metaValue}>{detail.duracao_ms ? `${detail.duracao_ms}ms` : '-'}</div>
              </div>
            </div>
            <div style={txStyles.metaCard}>
              <span style={{ ...txStyles.metaIcon, color: httpColor, fontWeight: '700', fontSize: '14px' }}>HTTP</span>
              <div>
                <div style={txStyles.metaLabel}>Status</div>
                <div style={{ ...txStyles.metaValue, color: httpColor }}>{detail.http_status || '-'}</div>
              </div>
            </div>
          </div>

          {/* Endpoint */}
          {detail.endpoint && (
            <div style={txStyles.endpointBar}>
              <span style={txStyles.endpointLabel}>ENDPOINT</span>
              <span style={txStyles.endpointUrl} title={detail.endpoint}>{detail.endpoint}</span>
              <button
                onClick={copyEndpoint}
                style={{
                  padding: '2px 8px', fontSize: '11px', border: '1px solid #ddd', borderRadius: '4px',
                  backgroundColor: endpointCopied ? '#e8f5e9' : '#fff', color: endpointCopied ? '#2e7d32' : '#888',
                  cursor: 'pointer', flexShrink: 0,
                }}
              >{endpointCopied ? 'Copiado!' : 'Copiar'}</button>
            </div>
          )}

          {/* Erros */}
          {detail.erro && (
            <div style={{ ...txStyles.alertBox, backgroundColor: '#ffebee', border: '1px solid #ffcdd2', color: '#c62828' }}>
              <span style={txStyles.alertIconSpan}>&#9888;</span>
              <div><strong>Erro:</strong> {detail.erro}</div>
            </div>
          )}
          {detail.soap_fault && (
            <div style={{ ...txStyles.alertBox, backgroundColor: '#fff3e0', border: '1px solid #ffe0b2', color: '#e65100' }}>
              <span style={txStyles.alertIconSpan}>&#9888;</span>
              <div><strong>SOAP Fault:</strong> {detail.soap_fault}</div>
            </div>
          )}

          {/* ===== TESTE CONEXAO ===== */}
          {isTesteConexao && testeData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Dados do Teste</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{testeData.prestador || testeData.cnpj || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Registro ANS</div>
                    <div style={txStyles.dataItemValue}>{testeData.registroANS || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Login</div>
                    <div style={txStyles.dataItemValue}>{testeData.login || '-'}</div>
                  </div>
                </div>
              </div>
              <div style={{
                ...txStyles.resultCard,
                ...(testeData.conectou ? txStyles.resultElegivel : txStyles.resultNaoElegivel),
              }}>
                <div style={{ ...txStyles.resultLabel, color: testeData.conectou ? '#2e7d32' : '#c62828' }}>
                  {testeData.conectou ? 'Conexao OK' : 'Falha na Conexao'}
                </div>
                {testeData.conectou ? (
                  <div style={{ fontSize: '13px', color: '#555' }}>
                    O servidor TISS respondeu corretamente. Credenciais e conectividade validadas.
                  </div>
                ) : (
                  <div style={{ fontSize: '13px', color: '#555' }}>
                    {testeData.codigoGlosa && (
                      <div style={txStyles.motivoItem}>
                        <span style={txStyles.motivoCodigo}>{testeData.codigoGlosa}</span>
                        <span style={txStyles.motivoDesc}>
                          {testeData.descricaoGlosa
                            || descreverGlosa(testeData.codigoGlosa)
                            || 'Erro retornado pelo servidor TISS'}
                        </span>
                      </div>
                    )}
                    {!testeData.codigoGlosa && 'Nao foi possivel estabelecer conexao com o servidor TISS.'}
                  </div>
                )}
              </div>
            </>
          )}

          {/* ===== ELEGIBILIDADE ===== */}
          {isElegibilidade && elegData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Dados da Verificacao</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Carteirinha</div>
                    <div style={txStyles.dataItemValue}>{elegData.carteirinha || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{elegData.prestador || '-'}</div>
                  </div>
                </div>
              </div>

              <div style={{
                ...txStyles.resultCard,
                ...(elegData.elegivel ? txStyles.resultElegivel : txStyles.resultNaoElegivel),
              }}>
                <div style={{ ...txStyles.resultLabel, color: elegData.elegivel ? '#2e7d32' : '#c62828' }}>
                  {elegData.elegivel ? 'Elegivel' : 'Nao Elegivel'}
                </div>
                {elegData.nomeBeneficiario && (
                  <div style={{ fontSize: '14px', color: '#555', marginBottom: elegData.motivos.length > 0 ? '10px' : '0' }}>
                    <strong>Beneficiario:</strong> {elegData.nomeBeneficiario}
                  </div>
                )}
                {elegData.motivos.length > 0 && (
                  <div>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: '#888', marginBottom: '4px' }}>Motivos da Negativa</div>
                    {elegData.motivos.map((m, i) => (
                      <div key={i} style={txStyles.motivoItem}>
                        <span style={txStyles.motivoCodigo}>{m.codigo}</span>
                        <span style={txStyles.motivoDesc}>{m.descricao}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          {/* ===== SOLICITACAO / WORKER / REENVIO GUIA ===== */}
          {isSolicitacao && solData && (() => {
            const statusSolMap = { '1': 'Autorizado', '2': 'Negado', '3': 'Pendente', '4': 'Cancelado', '5': 'Expirado' };
            const statusSolColorMap = { '1': '#2e7d32', '2': '#c62828', '3': '#e65100', '4': '#999', '5': '#999' };
            const statusSolBgMap = { '1': '#e8f5e9', '2': '#ffebee', '3': '#fff3e0', '4': '#f5f5f5', '5': '#f5f5f5' };
            const stLabel = statusSolMap[solData.statusSolicitacao] || '';
            const stColor = statusSolColorMap[solData.statusSolicitacao] || '#999';
            const stBg = statusSolBgMap[solData.statusSolicitacao] || '#f5f5f5';
            const isAutorizado = solData.statusSolicitacao === '1' || !!solData.senha;
            return (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Dados da Guia</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Carteirinha</div>
                    <div style={txStyles.dataItemValue}>{solData.carteirinha || '-'}</div>
                  </div>
                  {solData.nomeBeneficiario && (
                    <div style={txStyles.dataItem}>
                      <div style={txStyles.dataItemLabel}>Beneficiario</div>
                      <div style={txStyles.dataItemValue}>{solData.nomeBeneficiario}</div>
                    </div>
                  )}
                  {solData.numeroGuiaOperadora && (
                    <div style={txStyles.dataItem}>
                      <div style={txStyles.dataItemLabel}>Guia Operadora</div>
                      <div style={txStyles.dataItemValue}>{solData.numeroGuiaOperadora}</div>
                    </div>
                  )}
                  {solData.numeroProtocolo && (
                    <div style={txStyles.dataItem}>
                      <div style={txStyles.dataItemLabel}>Protocolo</div>
                      <div style={txStyles.dataItemValue}>{solData.numeroProtocolo}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Authorization details (UNIMED autorizacaoProcedimentoWS) */}
              {(solData.statusSolicitacao || solData.senha) && (
                <div style={{
                  ...txStyles.resultCard,
                  backgroundColor: isAutorizado ? '#e8f5e9' : stBg,
                  border: `1px solid ${isAutorizado ? '#c8e6c9' : stColor + '22'}`,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <div style={{ ...txStyles.resultLabel, color: isAutorizado ? '#2e7d32' : stColor, fontSize: '16px' }}>
                      {stLabel || (isAutorizado ? 'Autorizado' : 'Resposta')}
                    </div>
                    {solData.statusSolicitacao && (
                      <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '12px', fontWeight: '600', backgroundColor: stColor + '18', color: stColor }}>
                        Status: {solData.statusSolicitacao}
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '8px' }}>
                    {solData.senha && (
                      <div>
                        <div style={{ fontSize: '11px', color: '#888' }}>Senha/Autorizacao</div>
                        <div style={{ fontSize: '14px', fontWeight: '700', fontFamily: 'monospace', color: '#333' }}>{solData.senha}</div>
                      </div>
                    )}
                    {solData.numeroGuiaOperadora && (
                      <div>
                        <div style={{ fontSize: '11px', color: '#888' }}>Guia Operadora</div>
                        <div style={{ fontSize: '14px', fontWeight: '700', fontFamily: 'monospace', color: '#333' }}>{solData.numeroGuiaOperadora}</div>
                      </div>
                    )}
                    {solData.dataAutorizacao && (
                      <div>
                        <div style={{ fontSize: '11px', color: '#888' }}>Data Autorizacao</div>
                        <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>{solData.dataAutorizacao}</div>
                      </div>
                    )}
                    {solData.dataValidadeSenha && (
                      <div>
                        <div style={{ fontSize: '11px', color: '#888' }}>Validade Senha</div>
                        <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>{solData.dataValidadeSenha}</div>
                      </div>
                    )}
                  </div>

                  {/* Procedimentos autorizados */}
                  {solData.servicosAutorizados.length > 0 && (
                    <div style={{ marginTop: '12px', borderTop: '1px solid rgba(0,0,0,0.08)', paddingTop: '10px' }}>
                      <div style={{ fontSize: '11px', fontWeight: '600', color: '#888', marginBottom: '6px' }}>Procedimentos Autorizados</div>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                          <tr style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
                            <th style={{ textAlign: 'left', padding: '4px 6px', color: '#888', fontWeight: '600', fontSize: '10px' }}>Codigo</th>
                            <th style={{ textAlign: 'left', padding: '4px 6px', color: '#888', fontWeight: '600', fontSize: '10px' }}>Descricao</th>
                            <th style={{ textAlign: 'center', padding: '4px 6px', color: '#888', fontWeight: '600', fontSize: '10px' }}>Solic.</th>
                            <th style={{ textAlign: 'center', padding: '4px 6px', color: '#888', fontWeight: '600', fontSize: '10px' }}>Autoriz.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {solData.servicosAutorizados.map((sv, i) => (
                            <tr key={i} style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                              <td style={{ padding: '4px 6px', fontFamily: 'monospace', fontWeight: '500' }}>{sv.codigo}</td>
                              <td style={{ padding: '4px 6px', color: '#555' }}>{sv.descricao}</td>
                              <td style={{ padding: '4px 6px', textAlign: 'center' }}>{sv.quantidadeSolicitada || '-'}</td>
                              <td style={{ padding: '4px 6px', textAlign: 'center', fontWeight: '600', color: '#2e7d32' }}>{sv.quantidadeAutorizada || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {solData.motivos.length > 0 && (
                <div style={{ ...txStyles.resultCard, ...txStyles.resultNaoElegivel }}>
                  <div style={{ fontSize: '12px', fontWeight: '600', color: '#c62828', marginBottom: '4px' }}>Glosas / Motivos de Negativa</div>
                  {solData.motivos.map((m, i) => (
                    <div key={i} style={txStyles.motivoItem}>
                      <span style={txStyles.motivoCodigo}>{m.codigo}</span>
                      <span style={txStyles.motivoDesc}>{m.descricao}</span>
                    </div>
                  ))}
                </div>
              )}
            </>
            );
          })()}

          {/* ===== STATUS GUIA ===== */}
          {isStatusGuia && statusGuiaData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Consulta de Status</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Protocolo Consultado</div>
                    <div style={txStyles.dataItemValue}>{statusGuiaData.protocolo || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{statusGuiaData.prestador || '-'}</div>
                  </div>
                </div>
              </div>
              <div style={{
                ...txStyles.resultCard,
                backgroundColor: statusGuiaData.situacaoBg,
                border: `1px solid ${statusGuiaData.situacaoColor}22`,
              }}>
                <div style={{ ...txStyles.resultLabel, color: statusGuiaData.situacaoColor }}>
                  {statusGuiaData.situacao}
                </div>
                {(statusGuiaData.motivoNegativa || statusGuiaData.descricaoMotivo) && (
                  <div style={{ fontSize: '13px', color: '#555', marginTop: '6px' }}>
                    {statusGuiaData.motivoNegativa && (
                      <div><strong>Motivo:</strong> {statusGuiaData.motivoNegativa}</div>
                    )}
                    {statusGuiaData.descricaoMotivo && (
                      <div><strong>Descricao:</strong> {statusGuiaData.descricaoMotivo}</div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {/* ===== CANCELAMENTO GUIA ===== */}
          {isCancelamento && cancelData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Dados do Cancelamento</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Guia Prestador</div>
                    <div style={txStyles.dataItemValue}>{cancelData.numeroGuiaPrestador || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Tipo Guia</div>
                    <div style={txStyles.dataItemValue}>{cancelData.tipoGuia === '2' ? 'SP/SADT' : cancelData.tipoGuia || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{cancelData.prestador || '-'}</div>
                  </div>
                </div>
              </div>
              <div style={{
                ...txStyles.resultCard,
                ...(cancelData.protocoloRecebimento
                  ? { backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9' }
                  : { backgroundColor: '#fff3e0', border: '1px solid #ffe0b2' }),
              }}>
                <div style={{ ...txStyles.resultLabel, color: cancelData.protocoloRecebimento ? '#2e7d32' : '#e65100' }}>
                  {cancelData.protocoloRecebimento ? 'Cancelamento Confirmado' : 'Aguardando Confirmacao'}
                </div>
                {cancelData.protocoloRecebimento && (
                  <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>
                    <strong>Protocolo:</strong> {cancelData.protocoloRecebimento}
                    {cancelData.dataRecebimento && <span style={{ marginLeft: '16px' }}><strong>Data:</strong> {cancelData.dataRecebimento}</span>}
                  </div>
                )}
              </div>
            </>
          )}

          {/* ===== ENVIO LOTE / REENVIO LOTE ===== */}
          {isEnvioLote && loteData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Dados do Lote</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Numero do Lote</div>
                    <div style={txStyles.dataItemValue}>{loteData.numeroLote || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{loteData.prestador || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Guias no Lote</div>
                    <div style={txStyles.dataItemValue}>{loteData.totalGuias || '-'}</div>
                  </div>
                </div>
              </div>
              <div style={{
                ...txStyles.resultCard,
                ...(loteData.protocoloRecebimento
                  ? { backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9' }
                  : { backgroundColor: '#fff3e0', border: '1px solid #ffe0b2' }),
              }}>
                <div style={{ ...txStyles.resultLabel, color: loteData.protocoloRecebimento ? '#2e7d32' : '#e65100' }}>
                  {loteData.protocoloRecebimento ? 'Lote Recebido' : 'Aguardando Recebimento'}
                </div>
                {loteData.protocoloRecebimento && (
                  <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>
                    <strong>Protocolo:</strong> {loteData.protocoloRecebimento}
                    {loteData.dataRecebimento && (
                      <span style={{ marginLeft: '16px' }}>
                        <strong>Recebido em:</strong> {loteData.dataRecebimento}
                        {loteData.horaRecebimento && ` ${loteData.horaRecebimento}`}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {/* ===== STATUS LOTE ===== */}
          {isStatusLote && statusLoteData && (
            <>
              <div style={txStyles.dataSection}>
                <div style={txStyles.dataSectionTitle}>Consulta de Status do Lote</div>
                <div style={txStyles.dataGrid}>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Protocolo Consultado</div>
                    <div style={txStyles.dataItemValue}>{statusLoteData.protocolo || '-'}</div>
                  </div>
                  <div style={txStyles.dataItem}>
                    <div style={txStyles.dataItemLabel}>Prestador</div>
                    <div style={txStyles.dataItemValue}>{statusLoteData.prestador || '-'}</div>
                  </div>
                </div>
              </div>
              <div style={{
                ...txStyles.resultCard,
                backgroundColor: statusLoteData.situacaoBg,
                border: `1px solid ${statusLoteData.situacaoColor}22`,
              }}>
                <div style={{ ...txStyles.resultLabel, color: statusLoteData.situacaoColor }}>
                  {statusLoteData.situacao}
                </div>
                {statusLoteData.descricaoMotivo && (
                  <div style={{ fontSize: '13px', color: '#555', marginTop: '6px' }}>
                    <strong>Descricao:</strong> {statusLoteData.descricaoMotivo}
                  </div>
                )}
              </div>
            </>
          )}

          {/* XML Request / Response */}
          <div style={{ ...txStyles.dataSection, marginTop: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={txStyles.dataSectionTitle}>Dados SOAP</div>
              {(detail.xml_request || detail.xml_response) && (
                <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
                  {detail.xml_request && (
                    <button style={{ padding: '3px 10px', fontSize: '11px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', color: '#555', cursor: 'pointer' }} onClick={() => downloadXml(detail.xml_request, `tiss_request_tx${detail.id}.xml`)}>Download Request</button>
                  )}
                  {detail.xml_response && (
                    <button style={{ padding: '3px 10px', fontSize: '11px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', color: '#555', cursor: 'pointer' }} onClick={() => downloadXml(detail.xml_response, `tiss_response_tx${detail.id}.xml`)}>Download Response</button>
                  )}
                </div>
              )}
            </div>
            {detail.xml_request && <XmlViewer xml={detail.xml_request} title="XML Request" />}
            {detail.xml_response && <XmlViewer xml={detail.xml_response} title="XML Response" />}
            {!detail.xml_request && !detail.xml_response && (
              <div style={{ fontSize: '13px', color: '#999', fontStyle: 'italic' }}>Nenhum XML registrado para esta transacao.</div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
